import { ComputedRef, inject, markRaw } from 'vue'

import { POWER_MODE } from '@/const/common'
import { useModalsStore } from '@/store/modals'

import PowerModeModal from './components/PowerModeModal.vue'

export const usePowerMode = () => {

  const modalsStore = useModalsStore()

  const isPowerMode = inject<ComputedRef<boolean>>(POWER_MODE)

  const clickOnPowerMode = () => new Promise((resolve, reject) => {
    if (isPowerMode?.value) {
      resolve(true)
    } else {
      const modalInstance = modalsStore.init('power-mode-warning', markRaw(PowerModeModal))
      modalInstance?.open(10001, {
        onClose: () => {
          reject?.()
        },
        onEnterPowerMode: () => {
          resolve(true)
        }
      })
    }
  })

  return {
    clickOnPowerMode,
    isPowerMode
  }
}
